import { useDirectusStore } from "@/modules/directus/store/directus";
import { readItems } from "@directus/sdk";
import { defineStore } from "pinia";
import PlaceCategoryInterface from "../interfaces/PlaceCategoryInterface";
import PlaceInterface from "../interfaces/PlaceInterface";
import { ref, watch } from "vue";
import i18n from "@/plugins/i18n";

export const usePlaceStore = defineStore("place", () => {
  const directusStore = useDirectusStore();

  const categories = ref<PlaceCategoryInterface[]>([]);

  const placesByCategory = ref<PlaceInterface[]>([]);

  const getPlaceCategories = async () => {
    categories.value = (await directusStore.city?.request(
      readItems("place_categories", {
        fields: ["*", { child_categories: ["*"], parent_category: ["*"] }],
        filter: {
          language: { code: { _eq: i18n.global.locale.value } },
        },
      })
    )) as PlaceCategoryInterface[];
  };

  const getPlacesByCategory = async (placeCategory: PlaceCategoryInterface) => {
    placesByCategory.value = await fetchPlacesByCategory(placeCategory);
  };

  const fetchPlacesByCategory = async (
    placeCategory: PlaceCategoryInterface
  ) => {
    return (await directusStore.city?.request(
      readItems("places", {
        filter: {
          place_categories: { place_categories_id: { _eq: placeCategory.id } },
          language: { code: { _eq: i18n.global.locale.value } },
        },
      })
    )) as PlaceInterface[];
  };

  watch(
    () => directusStore.city,
    () => {
      categories.value = [];
      placesByCategory.value = [];

      getPlaceCategories();
    }
  );

  watch(
    () => i18n.global.locale.value,
    () => {
      categories.value = [];
      placesByCategory.value = [];

      getPlaceCategories();
    }
  );

  return {
    getPlaceCategories,
    getPlacesByCategory,
    fetchPlacesByCategory,
    categories,
    placesByCategory,
  };
});
